<template>
    <v-container fluid class="scroll-y fullscreen" pa-0>
        <v-card flat tile class="mx-auto overflow-hidden accent" min-height="calc(100vh - 112px)">
            <v-card flat tile class="primary">  
                <v-list flat color="#004889" class="py-0">
                    <v-list-item class="form-row">
                        <v-list-item-content>
                            <file-pond
                                name="filepond"
                                ref="filepond"
                                label-idle='Drag & Drop your files or <span class="filepond--label-action"> Browse </span>'
                                v-bind:allow-multiple="true"
                                v-bind:allowImagePreview="false"
                                accepted-file-types="image/jpeg, image/png"
                                :server="{
                                    url: 'https://api.mrpoolal.com/api/crm/ji/image?id='+job,
                                    process: {
                                        headers: {
                                            'Authorization': `Bearer ${token}`
                                        }
                                    }
                                }"
                                v-bind:files="files"
                                v-on:init="handleFilePondInit"
                                v-on:processfile="handleFilePondProcessfile"
                                class="mb-0"
                                />
                        </v-list-item-content>
                    </v-list-item>
                </v-list>            
            </v-card>
            <template>
                <v-card flat tile class="pa-0" color="accent">
                    <v-card-text class="ma-0 pa-0">
                        <vue-picture-swipe :items="imgitems" :mcats="media_categories" @update-images="getImages"></vue-picture-swipe>
                    </v-card-text>
                </v-card>
            </template>
        </v-card>
    </v-container>
</template>

<script>
    import axios from 'axios'
    import TokenService from '../../services/storage.service'
    import VuePictureSwipe from '../../components/Swipe/SwipeJi.vue'

    export default {
        props: ['job'],
        data () {
            return {
                comments: [], 
                customer: '',
                loading: false,
                token: '',
                pageTitle: '',
                drawer: false,
                files: [],
                uploadedFiles: [],
                images: [],
                media_categories: []
            }
        },
        created() {
            this.getImages()
            this.token = TokenService.getToken()
            this.pageTitle = this.$route.meta.title
        },
        components: {
            'vue-picture-swipe': VuePictureSwipe
        },
        computed: {
            filteredImages() {
                return this.images
            },
            imgitems() {
                var arr = [];
            
                this.filteredImages.forEach(item => {
                    //var meta = JSON.parse(item.image_meta);
                    var img = {}; 
                    img ["src"] = 'https://api.mrpoolal.com/img/jobissues/'+item.image;
                    img ["thumbnail"] = 'https://api.mrpoolal.com/img/jobissues/'+item.image+'?w=400&h=400&fit=crop';

                    let imgg = document.createElement('img');
                    imgg.id = 'imgId';
                    imgg.src = img ["src"];
                    document.body.appendChild(imgg);
                    let myImg = document.querySelector("#imgId");
                    img ["w"] = myImg.naturalWidth; // you modify it's properties
                    img ["h"] = myImg.naturalHeight; // you modify it's properties 
                    img ["id"] = item.id
                    arr.push(img); // you push it to the array
                });   

                return arr         
            }
        },
        methods: {
            getImages() {
                if(this.job) {
                    this.loading = true
                    axios.get('crm/ji/images?id=' + this.job)
                        .then((response) => {
                            this.loading = false
                            this.images = response.data.images
                            this.customer = response.data.customer
                            this.$nextTick()
                        })
                }
            },
            handleFilePondProcessfile: function (error, file) {
                if(this.images !== undefined)
                    this.images.push(JSON.parse(file.serverId))  
                    this.$nextTick()
            },
            getMeta(url, callback) {
                const img = new Image();
                img.src = url;
                img.onload = function() { callback(this.width, this.height); }
            }
        }
    }
</script>

<style lang="sass">
.filepond--panel-center
    &.filepond--panel-root
        outline: none!important
#imgId
    display: none
figure.gallery-thumbnail
    text-align: center
</style>